<template>
  <div class="container">
    <div class="page_header">
      <div class="mwow-detail-header">
        <div class="left">
          <div class="back-btn" @click="handleBack">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
        </div>
        <div class="mid">
          <p>结业学员明细数据</p>
        </div>
      </div>
    </div>
    <div class="content">
      <el-button
        class="mwow-button-filled primary"
        @click="handleExport"
        style="margin: 0 0 15px 15px"
        >导出</el-button
      >
      <common-search-form-wrapper
        :hiddenExpand="true"
        :reset="handleSearchReset"
      >
        <el-form
          size="mini"
          ref="form"
          :model="searchInfo"
          label-width="80px"
          label-position="right"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="结业时间:">
                <el-date-picker
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :clearable="false"
                  v-model="searchInfo.date"
                  @change="handleSearch"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结业分类:" prop="completion_category_id">
                <el-select
                  v-model.number="searchInfo.completion_category_id"
                  clearable
                  placeholder="请选择"
                  @change="handleSearch"
                >
                  <el-option label="距离远" :value="1"></el-option>
                  <el-option label="不感兴趣" :value="2"></el-option>
                  <el-option label="价格贵" :value="3"></el-option>
                  <el-option label="时间不合适" :value="4"></el-option>
                  <el-option label="艺考" :value="5"></el-option>
                  <el-option label="学业忙/工作忙" :value="6"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课程顾问：" prop="follow_staff_id">
                <el-select
                  v-model.number="searchInfo.follow_staff_id"
                  clearable
                  filterable
                  @change="handleSearch"
                  placeholder="请选择"
                  :filter-method="handleChangeFollowStaff"
                >
                  <el-option
                    v-for="item in followStaffList"
                    :key="item.staff_id"
                    :label="item.name"
                    :value="item.staff_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学员搜索:" prop="key_word">
                <el-input
                  v-model="searchInfo.key_word"
                  placeholder="学员姓名/手机号"
                  @change="handleSearch"
                  prefix-icon="el-icon-search"
                  clearable
                  maxlength="99"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结业原因:" prop="completion_remark">
                <el-input
                  v-model="searchInfo.completion_remark"
                  placeholder="请输入关键词"
                  @change="handleSearch"
                  prefix-icon="el-icon-search"
                  clearable
                  maxlength="99"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </common-search-form-wrapper>
      <div class="table-class">
        <el-table
          v-horizontal-scroll
          size="mini"
          :data="tableData"
          stripe
          style="width: 100%"
          tooltip-effect="dark"
          class="mwow-table micro"
        >
          <el-table-column
            label="序号"
            prop="serialNumber"
            width="50"
          ></el-table-column>
          <el-table-column label="结业时间" prop="completion_time">
            <template slot-scope="scope">
              {{ scope.row.completion.completion_time || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="学员姓名" prop="name"></el-table-column>
          <el-table-column label="手机号" prop="goods_name">
            <template slot-scope="scope">
              {{ "+" + scope.row.area_code }} {{ scope.row.mobile || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="性别" prop="sex">
            <template slot-scope="scope">
              <div v-if="scope.row.sex === 0">未知</div>
              <div v-if="scope.row.sex === 1">男</div>
              <div v-if="scope.row.sex === 2">女</div>
            </template>
          </el-table-column>
          <el-table-column label="年龄" prop="age"></el-table-column>
          <el-table-column label="课程顾问" prop="follow_staff.name">
            <template slot-scope="scope">
              {{ scope.row.follow_staff ? scope.row.follow_staff.name : "-" }}
            </template>
          </el-table-column>
          <el-table-column label="用户意向" prop="intent">
            <template slot-scope="scope">
              {{ followLatentObj[scope.row.completion.intent] || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="结业分类">
            <template slot-scope="scope">
              <div v-if="scope.row.completion.completion_category_id === 1">
                距离远
              </div>
              <div v-if="scope.row.completion.completion_category_id === 2">
                不感兴趣
              </div>
              <div v-if="scope.row.completion.completion_category_id === 3">
                价格贵
              </div>
              <div v-if="scope.row.completion.completion_category_id === 4">
                时间不合适
              </div>
              <div v-if="scope.row.completion.completion_category_id === 5">
                艺考
              </div>
              <div v-if="scope.row.completion.completion_category_id === 6">
                学业忙/工作忙
              </div>
            </template>
          </el-table-column>
          <el-table-column label="结业原因" prop="intent">
            <template slot-scope="scope">
              {{ scope.row.completion.completion_remark || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="首次入学时间" prop="transform_time">
            <template slot-scope="scope">
              {{ scope.row.completion.transform_time || "-" }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="pageSizeArray"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handlePagerChange"
        @size-change="handlePagerSizeChange"
        :style="{ float: 'right', padding: '17px' }"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import { staffList } from "@/api/globalSearch";
import {
  studentCompletionListApi,
  studentCompletionListExportApi,
} from "@/api/statistics";
import { dateFormat } from "@/utils/timeFormat";
import { getFollowLatentApi } from "@/api/studentFollow";
import { exportLoop } from "@/utils/export";

export default {
  components: {
    commonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        date: [],
        key_word: "",
        completion_remark: "",
      },
      followStaffList: [],
      tableData: [],
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      page: 1,
      followLatentObj: {},
    };
  },

  created() {
    if (this.$route.query.start_time) {
      this.searchInfo.date[0] = this.$route.query.start_time;
    }
    if (this.$route.query.end_time) {
      this.searchInfo.date[1] = this.$route.query.end_time;
    }
    this.handleChangeFollowStaff("");
    this.getList({
      page: 1,
      page_size: 10,
    });
    getFollowLatentApi().then((res) => {
      const obj = {};
      res.data.list.map((item) => {
        obj[item.key] = item.value;
      });
      this.followLatentObj = obj;
    });
  },
  methods: {
    handleChangeFollowStaff(v) {
      staffList({
        page: 1,
        page_size: 50,
        key_word: v,
        job_ids: [3],
      }).then((res) => {
        this.followStaffList = res.data.list;
      });
    },
    handleBack() {
      this.$router.go(-1);
    },
    handleExport() {
      const option = {
        page: this.page,
        page_size: this.pageSize,
      };
      if (this.searchInfo.date && this.searchInfo.date.length > 0) {
        option.start_date = this.searchInfo.date[0];
        option.end_date = this.searchInfo.date[1];
      }
      if (this.searchInfo.completion_category_id) {
        option.completion_category_ids = this.searchInfo.completion_category_id;
      }
      if (this.searchInfo.follow_staff_id) {
        option.follow_staff_ids = this.searchInfo.follow_staff_id;
      }
      if (this.searchInfo.key_word) {
        option.key_word = this.searchInfo.key_word;
      }
      if (this.searchInfo.completion_remark) {
        option.completion_remark = this.searchInfo.completion_remark;
      }
      studentCompletionListExportApi(option).then((res) => {
        if (res.error_code === 0) {
          exportLoop(res.data.task_id);
        }
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (this.searchInfo.date && this.searchInfo.date.length > 0) {
        option.start_date = this.searchInfo.date[0];
        option.end_date = this.searchInfo.date[1];
      }
      if (this.searchInfo.completion_category_id) {
        option.completion_category_ids = [
          this.searchInfo.completion_category_id,
        ];
      }
      if (this.searchInfo.follow_staff_id) {
        option.follow_staff_ids = [this.searchInfo.follow_staff_id];
      }
      if (this.searchInfo.key_word) {
        option.key_word = this.searchInfo.key_word;
      }
      if (this.searchInfo.completion_remark) {
        option.completion_remark = this.searchInfo.completion_remark;
      }
      studentCompletionListApi(option).then((res) => {
        if (res.error_code === 0) {
          let serialNumber = 0;
          res.data.list.map((item) => {
            serialNumber++;
            item.serialNumber = serialNumber;
            item.completion.completion_time = dateFormat(
              "YYYY-mm-dd",
              item.completion.completion_time * 1000
            );
            item.completion.transform_time = dateFormat(
              "YYYY-mm-dd",
              item.completion.transform_time * 1000
            );
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleSearchReset() {
      this.searchInfo = {
        date: [this.$route.query.start_time, this.$route.query.end_time],
        key_word: "",
        completion_remark: "",
      };
      this.page = 1;
      this.pageSize = 10;
      this.handleSearch();
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  .page_header {
    background: #fff;
    padding: 0 13px;
  }
  .content {
    margin-top: 15px;
    .table-class {
      margin-top: 15px;
      padding: 0 15px;
    }
  }
}
/deep/ .buttons {
  position: relative;
  right: 8px;
}
</style>
